//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { DefaultIconButton } from '@components/atoms/button/Button';
import { BodyText } from '@components/atoms/text/Text';
import { SmallTooltip } from '@components/molecules/tooltip/Tooltip';
import { MediaLibraryTrackingIds } from '@media-library/constants/mediaLibraryTrackingIds';

interface ShowFilterPanelButtonProps {
  onClick: () => void;
}

export const ShowFilterPanelButton = ({
  onClick,
}: ShowFilterPanelButtonProps) => {
  return (
    <SmallTooltip
      content={<StyledTooltipText>Toggle Filters</StyledTooltipText>}
      interactive={false}
      placement='left'
      target={
        <StyledButton
          iconName='filters'
          onClick={onClick}
          trackingId={MediaLibraryTrackingIds.TOGGLE_FILTER_PANEL}
        />
      }
    />
  );
};

const StyledTooltipText = styled(BodyText)(
  ({ theme }) => `
  padding: ${theme.spacings[2]};
`,
);

const StyledButton = styled(DefaultIconButton)(
  ({ theme }) => `
  button {
    padding: ${theme.spacings[2]} ${theme.spacings[3]};
  }
`,
);
